import benefitsDataPl from '../data/BenefitsData/benefitsDataPl';
import { LangData } from '../types/langTypes';

const pl: LangData = {
  id: 'pl',
  name: 'Polski',
  images: [],
  altText: '',
  description: '',
  portfolioDescription1: 'Responsywna strona typu one-page dla marki lodów: zawiera przegląd produktów, sekcję „jak to powstaje”, galerię oraz formularz kontaktowy. Zbudowana w HTML, CSS (mobile-first) i JavaScript.',
  portfolioDescription2: "Nowoczesna responsywna aplikacja e-commerce z przejrzystym UI/UX, filtrowaniem produktów w czasie rzeczywistym, zarządzaniem koszykiem i układem mobile-first. Wykorzystane technologie: React, TypeScript, Redux oraz SCSS.",
  portfolioDescription3: "",
  portfolioDescription4: "",
  portfolioDescription5: "",
  portfolioDescription6: "",
  portfolioDescription: 'Opis portfolio',
  backToTop: 'Do góry',
  toggleMenu: "Przełącz menu",
  mainNavigationLabel: "Główna nawigacja",
  mainNavigation: ['Strona główna', 'O nas', 'Usługi', 'Portfolio', 'Kontakt'],
  logoTaglines: {
    top: "Myśl odważnie",
    bottom: "Twórz mądrze",
  },
  home: "Strona główna",
  about: "O nas",
  aboutmain: "O nas",
  aboutTitle: "O NAS",
  aboutSubtitle: "Architekci cyfrowej przewagi",
  aboutText: "SYDRIX to miejsce, gdzie wysoka estetyka inżynieryjna spotyka się z bezkompromisową efektywnością biznesową. Założone przez ukraińskiego wizjonera technologii w sercu Bawarii, nasze studio stało się synonimem cyfrowej odporności i innowacji. Nie tylko tworzymy interfejsy – budujemy aktywa cyfrowe wyprzedzające rynek. Nasze podejście opiera się na trzech filarach: Performance-First (prędkość jako religia), Inclusive Design (dostępność jako standard) oraz Scalable Architecture (gotowość na dziesięciokrotny wzrost Twojego biznesu). Wierzymy, że idealny kod powinien być niewidoczny, ale wynik musi być odczuwalny w każdym raporcie zysków. Z SYDRIX otrzymujesz nie tylko frontend, ale przewagę technologiczną, która zmienia Twoją markę w lidera epoki cyfrowej.",
  aboutPhilosophyTitle: "Nasza filozofia",
  aboutPhilosophyText: "Zastępujemy przestarzałe metody świeżym spojrzeniem na wydajność. Nasze podejście gwarantuje architekturę, która nie będzie wymagała poprawek przez lata.",
  aboutButton: "Dowiedz się więcej",
  aboutButtonText: "Zobacz",
  aboutButtonLink: "/about",
  aboutImageAlt: "Zdjęcie o nas",
  aboutList: ["Profesjonalny zespół", "Nowoczesne technologie", "Indywidualne podejście"],
  aboutQuote: "Kochamy to, co robimy!",
  aboutQuoteAuthor: "Założyciel zespołu",
  aboutStats: [
    { label: "Stack technologiczny", value: "Next.js" },
    { label: "Skupienie na jakości", value: "100%" }
  ],
  aboutMission: "Przekształcamy złożone technologie w Twoje strategiczne aktywa, zapewniając liderstwo biznesowe w erze cyfrowej.",
  aboutVision: "Stać się globalnym punktem odniesienia w inżynierii frontendowej, gdzie każdy piksel pracuje na zysk klienta.",
  aboutValues: ["Doskonałość inżynieryjna", "Radykalna przejrzystość", "Skalowalne innowacje"],
  aboutTeam: "Nasz zespół to nasz główny kapitał.",
  aboutPartners: "Nasi partnerzy nam ufają.",
  aboutClients: "Nasi klienci to nasi przyjaciele.",
  aboutHistory: "Historia firmy rozpoczęła się w 2025 roku.",
  services: "Usługi",
  servicesTitle: "Nasze usługi",
  servicesContactText: "Skontaktuj się z nami po więcej informacji",
  servicesButton: "Dowiedz się więcej",
  servicesFormTitle: "Bezpłatna konsultacja",
  servicesFormPlaceholder: "Twój e-mail",
  servicesFormButton: "Wyślij",
  showLessButton: "Pokaż mniej",
  showMoreButton: "Pokaż więcej",

  portfolio: "Portfolio",
  portfolioTitle: "Portfolio",
  portfolioText: "Zrealizowane pomysły",
  portfolioLabel: "Portfolio",
  testimonials: "Opinie",
  testimonialsText: "Dziękujemy wszystkim naszym klientom za opinie!",
  blogTitle: "Blog",
  contacts: "Kontakt",
  contactsTitle: "Kontakt",
  phone: "Telefon",
  email: "E-mail",
  faq: "FAQ",
  partnership: "Współpraca",
  showAllButton: "Pokaż wszystkie",
  hideAllButton: "Ukryj",
  title: "Frontend dla Twojego biznesu",
  subtitle: [
    "Imponująca szybkość.",
    "Niezapomniany design.",
    "Zachwycające doświadczenie."
  ],
  button: "Porozmawiajmy",
  benefitsTitle: "Korzyści ze współpracy",
  benefitsSubtitle: "Dlaczego klienci wybierają nas",
  benefitsText: "Tworzymy strony szybkie, bezpieczne i wydajne.",
  benefits: benefitsDataPl,
  goTo: "przejdź do",
  footer: "Stworzone przez Artema Sydorova",
  heroTitle: "Frontend dla Twojego biznesu",
  heroSubtitle: [
    "Imponująca szybkość.",
    "Niezapomniany design.",
    "Zachwycające doświadczenie."
  ],
  heroButton: "Porozmawiajmy",
  portfolioLink: "/portfolio",
  portfolioLinkText: "Zobacz portfolio",
  viewOnGithub: "Zobacz na GitHubie",
  noProjectsFound: "Nie znaleziono projektów.",

  serviceDetailsTitle: "Szczegóły usługi",
  serviceDetailsText: "Szczegółowe informacje o naszych usługach.",
  servicesDetailsButton: "Dowiedz się więcej o usłudze",
  servicesDetailsSubtitle: "Więcej o naszych usługach",
  servicesDetailsList: ["Usługa 1", "Usługa 2", "Usługa 3"],
  notFoundTitle: "Strona nie znaleziona",
  notFoundText: "Przepraszamy, ta strona nie istnieje.",
  notFoundButton: "Wróć do strony głównej",
  cookieConsentText: "Ta strona używa plików cookie w celu poprawy komfortu użytkowania.",
  cookieConsentButton: "Zrozumiałem",
  privacyPolicy: "Polityka prywatności",
  termsOfService: "Regulamin",
  loading: "Ładowanie...",
  error: "Wystąpił błąd. Spróbuj ponownie.",
  success: "Sukces!",
  language: "Język",
  selectLanguage: "Wybierz język",
  close: "Zamknij",

  serviceDetailsBack: "Powrót do usług",
  faqTitle: "Najczęściej zadawane pytania",
  faqSubtitle: "Odpowiedzi na najczęstsze pytania",
  faqText: "Masz pytania? Zajrzyj tutaj lub skontaktuj się z nami.",
  team: "Zespół",
  teamTitle: "Nasz zespół",
  teamText: "Jesteśmy zespołem pasjonatów i profesjonalistów.",
  process: "Proces",
  processTitle: "Jak pracujemy",
  processText: "Pracujemy w przejrzysty sposób.",
  technologies: "Technologie",
  technologiesTitle: "Technologie, których używamy",
  technologiesText: "Stosujemy nowoczesne frameworki i narzędzia.",
  price: "Cennik",
  priceTitle: "Ceny usług",
  priceText: "Poznaj ceny naszych usług.",

  processSubtitle: "Etapy naszej pracy",
  teamSubtitle: "Poznaj nasz zespół",
  teamButton: "Więcej o zespole",
  teamButtonText: "Zobacz zespół",
  processButton: "Więcej o procesie",
  processButtonText: "Zobacz proces",
  technologiesSubtitle: "Nasze technologie",
  technologiesButton: "Więcej o technologiach",
  technologiesButtonText: "Zobacz technologie",
  priceSubtitle: "Szczegóły cen",
  priceButton: "Więcej o cenach",
  priceButtonText: "Zobacz cennik",

  teamButtonLink: "/team",
  portfolioButton: "Więcej o portfolio",
  portfolioButtonText: "Zobacz portfolio",
  portfolioButtonLink: "/portfolio",
  blogButton: "Więcej o blogu",
  blogButtonText: "Zobacz blog",
  blogButtonLink: "/blog",
  contactsButton: "Więcej o kontaktach",
  contactsButtonText: "Zobacz kontakt",
  contactsButtonLink: "/contacts",
  faqButton: "Więcej o FAQ",
  faqButtonText: "Zobacz FAQ",
  faqButtonLink: "/faq",
  notFoundButtonText: "Wróć do strony głównej",
  cookieConsentMore: "Dowiedz się więcej",
  privacyPolicyButton: "Zobacz politykę",
  termsOfServiceButton: "Zobacz regulamin",

  contactsButtonLinkText: "Przejdź do kontaktu",
  cookieConsentLink: "/privacy-policy",
  privacyPolicyButtonText: "Zobacz politykę prywatności",
  termsOfServiceButtonText: "Zobacz warunki",
  aboutButtonLinkText: "Więcej o nas",
  servicesButtonLinkText: "Więcej o usługach",
  portfolioButtonLinkText: "Więcej o portfolio",
  blogButtonLinkText: "Więcej o blogu",
  faqButtonLinkText: "Więcej o FAQ",
  teamButtonLinkText: "Więcej o zespole",
  processButtonLinkText: "Więcej o procesie",
  technologiesButtonLinkText: "Więcej o technologiach",
  priceButtonLinkText: "Więcej o cenniku",
  notFoundButtonLinkText: "Wróć do strony głównej",
  cookieConsentButtonText: "Zrozumiałem",
  cookieConsentMoreText: "Dowiedz się więcej",

  faqQuestion: "Pytanie",
  faqAnswer: "Odpowiedź",
  priceButtonLink: "/price",
  processButtonLink: "/process",
  technologiesButtonLink: "/technologies",
  servicesButtonLink: "/services",
  notFoundButtonLink: "/",
  privacyPolicyLink: "/privacy-policy",
  termsOfServiceLink: "/terms-of-service",

  partnershipTitle: "Współpraca",
  partnershipSubtitle: "Możliwości współpracy",
  partnershipText: "Jesteśmy otwarci na nowe współprace i możliwości.",
  notFoundBackButton: "Wróć",
  extraField1: "Dodatkowe pole 1",
  extraField2: "Dodatkowe pole 2",
  notFoundLink: "/",
  cookieConsent: "Ta strona używa plików cookie w celu poprawy komfortu użytkowania.",
  noPortfolioItems: 'Portfolio jest obecnie puste',
  noImages: 'Brak dostępnych obrazów',
  "impressum.back": "Retour",
  "impressum.subtitle": "Mentions Légales",
  "impressum.infoTitle": "Informations selon § 5 TMG",
  "impressum.owner": "Propriétaire",
  "impressum.address": "Hochriesstraße 29",
  "impressum.city": "83209 Prien am Chiemsee, Niemcy",
  "impressum.contactTitle": "Contact",
  "impressum.email": "E-mail",
  "impressum.website": "Site web",
  "impressum.copyrightTitle": "Droit d'auteur",
  "impressum.rights": "Tous droits réservés.",
  "impressum.disputeTitle": "Règlement des litiges",
  "impressum.disputeText": "La Commission européenne propose une plateforme de règlement des litiges en ligne (OS) :",
  "impressum.disputeFinal": "Je ne suis pas obligé de participer à une procédure de règlement des litiges devant un conseil d'arbitrage.",
  "impressum.disclaimerTitle": "Wyłączenie odpowiedzialności",
  "impressum.disclaimerText": "Odpowiedzialność za treści: Treści naszych stron zostały przygotowane z najwyższą starannością. Nie możemy jednak zagwarantować ich poprawności, kompletności ani aktualności. Jako dostawca usług odpowiadamy za własne treści na tych stronach zgodnie z ogólnymi przepisami prawa. Odpowiedzialność за linki: Nasza oferta zawiera linki do zewnętrznych stron internetowych osób trzecich, na których treści nie mamy wpływu i nie ponosimy za nie odpowiedzialności.",
  "impressum.taxStatus": "Zgodnie з § 19 UStG podatek VAT nie jest naliczany (status małej firmy).",
  "impressum.responsible": "Osoba odpowiedzialna za treść zgodnie z § 18 MStV",
  "impressum.phone": "Telefon",
  "impressum.copyrightText": "Treści i utwory stworzone przez właściciela witryny na tych stronach podlegają prawu autorskiemu. Powielanie, przetwarzanie, rozpowszechnianie i wszelkiego rodzaju wykorzystywanie poza zakresem prawa autorskiego wymaga pisemnej zgody autora.",
  "impressum.copyrightLinkText": "Niemiecka ustawa o prawie autorskim (UrhG)",

  "privacy.title": "Polityka prywatności",
  "privacy.intro": "Bardzo poważnie traktuję ochronę Państwa danych osobowych. Niniejsza strona została zaprojektowana tak, aby przetwarzać jak najmniej danych.",
  "privacy.hostingTitle": "1. Hosting zewnętrzny",
  "privacy.hostingText": "Niniejsza strona internetowa jest hostowana przez zewnętrznego dostawcę usług (hostera). Dane osobowe gromadzone na tej stronie są przechowywane na serwerach hostera. Obejmuje to głównie adresy IP i metadane. Korzystanie з usług hostera następuje w celu zapewnienia bezpiecznego i szybkiego świadczenia naszych usług online przez profesjonalnego dostawcę (Art. 6 ust. 1 lit. f RODO).",
  "privacy.dataTitle": "2. Minimalizacja danych",
  "privacy.dataText": "W trosce o minimalizację danych, niniejsza strona rezygnuje z używania plików cookie, narzędzi analitycznych (trackingu) oraz formularzy kontaktowych. Nie odbywa się żadna ocena zachowań użytkowników.",
  "privacy.rightsTitle": "3. Prawa osoby, której dane dotyczą",
  "privacy.rightsText": "W ramach obowiązujących przepisów prawnych mają Państwo w każdej chwili prawo do bezpłatnej informacji o Państwa przechowywanych danych osobowych, a także prawo do ich sprostowania lub usunięcia.",
  "privacy.contactTitle": "4. Podmiot odpowiedzialny",
  "privacy.contactText": "Osobą odpowiedzialną za przetwarzanie danych jest Artem Sydorov. Pełne dane kontaktowe znajdują się w sekcji Impressum na tej stronie.",
};

export default pl;
